import useDeleteLocation from 'api/homePage/useDeleteLocation/useDeleteLocation';
import useEditLocation from 'api/homePage/useEditLocation/useEditLocation';
import useInsertLocation from 'api/homePage/useInsertLocation/useInsertLocation';
import useLocationList from 'api/homePage/useLocationList/useLocationList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import LocationEditModal from 'components/shared/Modals/homePage/LocationEditModal/LocationEditModal';
import LocationInsertModal from 'components/shared/Modals/homePage/LocationInsertModal/LocationInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useLocationsTableColumns from 'hooks/homePage/useLocationsTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const HomePage = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getLocationList, loading, locationList, pageRef] = useLocationList();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [editChosenLocation, setEditChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [insertLoading, setInsertLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [insertInputValue, setInsertInputValue] = useState('');

  const [deleteRequest] = useDeleteLocation();
  const [editRequest] = useEditLocation();
  const [insertRequest] = useInsertLocation();

  const navigate = useNavigate();
  const { can } = usePermissions();

  const locationPermissions =
    permissions.general.categories.warehouseManagement.locationManagement
      .locations;

  const canCreate = can(locationPermissions.create);
  const canDelete = can(locationPermissions.delete);
  const canDetail = can(locationPermissions.detail);
  const canEdit = can(locationPermissions.edit);

  const tableRef = useRef(null);

  useEffect(() => {
    getLocationList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getLocationList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/locations/${row.id}`),
    [],
  );
  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );
  const editItem = useCallback(
    row => () => {
      setInputValue(row.title);
      setEditChosenLocation(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useLocationsTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getLocationList, setIsDeleteModalOpen, setDeleteLoading);
  };

  const editHandle = id => {
    if (inputValue) {
      setEditLoading(true);
      editRequest(
        id,
        getLocationList,
        setIsEditModalOpen,
        setEditLoading,
        inputValue,
      );
    }
  };

  const insertHandle = () => {
    if (insertInputValue) {
      setInsertLoading(true);
      insertRequest(
        getLocationList,
        setIsInsertModalOpen,
        setInsertLoading,
        insertInputValue,
        setInsertInputValue,
      );
    }
  };

  const editInputHandler = e => setInputValue(e.target.value);

  const closeDeleteModal = () => setIsDeleteModalOpen(false);
  const closeEditModal = () => setIsEditModalOpen(false);

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getLocationList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getLocationList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(locationList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={locationList[page]}
          rows={locationList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت مکان جدید' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={closeDeleteModal}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <LocationEditModal
          open={isEditModalOpen}
          handleClose={closeEditModal}
          title={editChosenLocation.title}
          locationId={editChosenLocation.id}
          editLoading={editLoading}
          onEdit={editHandle}
          editInputValue={inputValue}
          inputOnchange={editInputHandler}
        />
      ) : null}

      {canCreate ? (
        <LocationInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          insertLoading={insertLoading}
          onInsert={insertHandle}
          insertInputValue={insertInputValue}
          insertInputOnchange={e => setInsertInputValue(e.target.value)}
        />
      ) : null}
    </>
  );
};

export default HomePage;
